import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

import { HeaderType } from '@utils/types';

import { TableRow, TableCell } from '@components/share/Table/table.style';
import theme from '@styles/theme';

type PossessionTableRowType = {
    header: HeaderType[];
    data: any;
};

const PossessionTableRow = ({ header = [], data }: PossessionTableRowType) => {
    const navigate = useNavigate();
    return (
        <TableRow
            onClick={() => navigate(`/equipment/${data?.id}`)}
            $noBorder
            $bold
        >
            <TableCell $minWidth={header[0].minWidth} $width={header[0].width}>
                {data?.order || '-'}
            </TableCell>
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                {data?.deviceName || '-'}
            </TableCell>
            <TableCell $minWidth={header[2].minWidth} $width={header[2].width}>
                {data?.location || '-'}
            </TableCell>
            <TableCell $minWidth={header[3].minWidth} $width={header[3].width}>
                {data?.version || '-'}
            </TableCell>
            <TableCell $minWidth={header[4].minWidth} $width={header[4].width}>
                {data?.installedAt
                    ? `${dayjs(data?.installedAt).format('YYYY-MM-DD')}`
                    : '-'}
            </TableCell>
            <TableCell
                $minWidth={header[5].minWidth}
                $width={header[5].width}
                $fontColor={theme.colors.deepGrayFontColor}
                $alignRight
            >
                {data?.duration ? `${data?.duration}개월` : '-'}
            </TableCell>
        </TableRow>
    );
};

export default memo(PossessionTableRow);
